import React from "react";

export function ComingSoonBadge({ className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border border-white/40 bg-white/15 text-white font-display text-[10px] uppercase tracking-[0.22em] font-bold ${className}`}
      data-testid="badge-coming-soon"
    >
      <span className="w-1 h-1 rounded-full bg-white" />
      Coming soon
    </span>
  );
}

export function StatusBadge({ status }) {
  const styles = {
    available:
      "border-emerald-400/40 bg-emerald-500/15 text-emerald-200",
    inDevelopment:
      "border-brand-purpleLight/50 bg-brand-purple/30 text-white",
    planned:
      "border-brand-orange/50 bg-brand-orange/15 text-brand-orange",
    futureVision:
      "border-white/25 bg-white/10 text-white/80",
  };
  const labels = {
    available: "Available",
    inDevelopment: "In development",
    planned: "Planned",
    futureVision: "Future vision",
  };
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border font-display text-[10px] uppercase tracking-[0.22em] font-bold ${styles[status]}`}
      data-testid={`status-${status}`}
    >
      <span className="w-1 h-1 rounded-full bg-current" />
      {labels[status]}
    </span>
  );
}
